import * as React from "react";
import {
  makeStyles,
  createStyles,
  Theme,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import Loader from "../components/Loader";
import moment from "moment";
import "moment/locale/fr";
import { ApiDouaneType, ApiDouaneTypeLabel } from "lib/api";
import { useApiClient } from "lib/store";
import { useErrorHandler } from "../../ErrorHandler";
import { AnvokError } from "lib";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 400,
    },
  })
);

type CloseCallback = (id?: string, type?: ApiDouaneType) => void;

interface Props {
  onClose: CloseCallback;
}

const Create: React.FunctionComponent<Props> = ({ onClose }) => {
  const api = useApiClient();
  moment.locale("fr");
  const defaultLabel = `Inventaire du ${moment().format("LL")}`;
  const [loading, setLoading] = React.useState("");
  const [label, setLabel] = React.useState(defaultLabel);
  const [labelError, setLabelError] = React.useState("");
  const [type, setType] = React.useState<ApiDouaneType>(ApiDouaneType.FULL);
  const errorHandler = useErrorHandler();
  const classes = useStyles();

  function handleTypeChange(event: React.ChangeEvent<{ value: unknown }>) {
    const type: ApiDouaneType = event.target.value as ApiDouaneType;
    const typeName = ApiDouaneTypeLabel.get(type);
    setType(type);
    setLabel(`${typeName} du ${moment().format("LL")}`);
  }

  function handleSave() {
    if (label.trim().length === 0) {
      setLabelError("Valeur requise");
      return;
    }
    setLabelError("");
    setLoading("Préparation...");

    api
      .POST("/api/douanes", { body: { label, type } })
      .then((r) => {
        if (r.error) {
          throw new AnvokError(r.error.message);
        }
        const { id } = r.data;
        setLoading("");
        onClose(id, type);
      })
      .catch(errorHandler);
  }

  return (
    <Dialog
      open={true}
      onClose={() => onClose()}
      aria-labelledby="types-form-dialog-title"
      classes={{ paper: classes.root }}
    >
      <Loader show={Boolean(loading)} message={loading}>
        <DialogTitle id="types-form-dialog-title">Création</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel shrink>Type</InputLabel>
            <Select fullWidth value={type} onChange={handleTypeChange}>
              {Array.from(ApiDouaneTypeLabel).map(([k, v]) => {
                return (
                  <MenuItem key={k} value={k}>
                    {v}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            label="Intitulé"
            value={label}
            error={Boolean(labelError)}
            helperText={labelError}
            fullWidth
            onChange={(e) => {
              setLabel(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()} color="primary">
            Annuler
          </Button>
          <Button onClick={handleSave} color="primary">
            Enregistrer
          </Button>
        </DialogActions>
      </Loader>
    </Dialog>
  );
};

export default Create;
